import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApprovedPartnersInterface } from '../../models/dashboard/dashboard/approved-partners';

interface IInitialState {
  approvedPartners?: ApprovedPartnersInterface;
}

const initialState: IInitialState = {
  approvedPartners: undefined
};

const approvedPartnersDataSlice = createSlice({
  name: 'approvedPartnersSlice',
  initialState,
  reducers: {
    setApprovedPartners(state, action: PayloadAction<ApprovedPartnersInterface>) {
      state.approvedPartners = action.payload;
    },
  },
});

export const approvedPartnersDataActions = approvedPartnersDataSlice.actions;
export default approvedPartnersDataSlice.reducer;
